
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function ACPCladding() {



  const cardData =
  {
    keyword: 'ACP Cladding Panel Installation ',
    heading: 'Anjali Enterprises: ACP Cladding Panel Installation ',
    headingDescription: 'Anjali Enterprises specializes in ACP (Aluminum Composite Panel) cladding panel installation in Pune, offering top-notch services for both residential and commercial buildings. Our ACP cladding solutions are designed to enhance the exterior aesthetics, durability, and insulation of your property, ensuring that it stands out while maintaining long-lasting quality.',

    topPlaces: [
        {
          "title": "Aluminum Door Partitions",
          "description": "We offer high-quality aluminum door partitions that are durable, lightweight, and sleek. These partitions are perfect for modern offices and homes, providing a sophisticated touch while maintaining privacy and functionality."
        },
        {
          "title": "Glass Door Partitions",
          "description": "Our glass door partitions are designed to create elegant and open spaces while maintaining privacy. They are ideal for offices and commercial spaces, providing a modern and transparent look that fosters collaboration and light flow."
        },
        {
          "title": "Custom Door Partitions",
          "description": "At Anjali Enterprises, we specialize in creating custom door partitions to meet your specific design and functional needs. Whether you need a unique style or particular material, we deliver tailored solutions that align with your vision."
        },
        {
          "title": "Office Door Partition Installation",
          "description": "Our team offers professional office door partition installation, ensuring a smooth and efficient process. We work closely with clients to create functional and aesthetically pleasing office spaces with high-quality door partitions."
        },
        {
          "title": "Door Partition Work in Pune",
          "description": "As a leading service provider in Pune, we handle all aspects of door partition work, from consultation to installation. Whether you need a simple partition or a complex design, our expert team guarantees precision and quality."
        },
        {
          "title": "Modern Door Partitions",
          "description": "Stay ahead with our modern door partitions, combining innovative designs and premium materials. These partitions are perfect for creating contemporary and stylish spaces, both at home and in the office."
        },
        {
          "title": "Wooden Door Partitions",
          "description": "For a classic and warm look, we provide wooden door partitions that add a touch of elegance to any space. Ideal for homes and offices, wooden partitions offer durability and timeless beauty."
        },
        {
          "title": "Sliding Door Partition for Office",
          "description": "Maximize space with sliding door partitions for your office. These partitions are ideal for offices with limited space, offering flexibility and easy movement while maintaining a sleek appearance."
        },
        {
          "title": "Partition Door Installation",
          "description": "Our professional installation team ensures the seamless installation of partition doors, taking care of all technical and aesthetic requirements. We focus on delivering high-quality, functional, and visually pleasing results."
        },
        {
          "title": "Door Partition for Home and Office",
          "description": "Anjali Enterprises provides door partition solutions for both homes and offices. Whether you’re looking to create private spaces at home or enhance your office layout, our door partitions offer the perfect solution for privacy and style."
        },
        {
          "title": "Pune Door Partition Service",
          "description": "As one of Pune’s leading door partition service providers, we are known for delivering high-quality installations with attention to detail. Our services ensure that your space is optimized for both functionality and aesthetics."
        },
        {
            "title": "Anjali Enterprises Contact Number:",
            "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality ACP cladding panel installation services. We specialize in the installation of ACP (Aluminum Composite Panel) cladding for both commercial and residential properties, providing durable, stylish, and modern cladding solutions. Get in touch for expert installation, ensuring both aesthetic appeal and long-lasting performance. Serving Pune with professional ACP cladding panel installation services. Contact us for a seamless experience and top-notch service."
          }
      ],
      "tableData": [
        ["- Aluminum Door Partitions", "- Glass Door Partitions"],
        ["- Custom Door Partitions", "- Office Door Partition Installation"],
        ["- Door Partition Work in Pune", "- Modern Door Partitions"],
        ["- Wooden Door Partitions", "- Sliding Door Partition for Office"],
        ["- Partition Door Installation", "- Door Partition for Home and Office"],
        ["- Pune Door Partition Service", ""]
      ],


   "whychoose": [
  {
    "WhyChooseheading": "Expert ACP Cladding Solutions",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in offering premium ACP (Aluminum Composite Panel) cladding installation services, designed for both residential and commercial buildings. ACP cladding combines modern aesthetics with exceptional durability, providing your building with a sleek, sophisticated look while ensuring low maintenance. With years of expertise in ACP cladding, we ensure flawless installations that enhance the overall design and value of your property."
  },
  {
    "WhyChooseheading": "Custom Designs and Styles",
    "WhyChoosedescription": "We recognize that each building has its unique style and design requirements. That's why we offer a wide range of ACP cladding options in various colors, textures, and finishes, allowing us to tailor solutions that enhance the visual appeal of your property. Whether you’re looking for a contemporary finish or a more traditional appearance, our custom ACP cladding installations are designed to meet your aesthetic vision."
  },
  {
    "WhyChooseheading": "Durability and Protection",
    "WhyChoosedescription": "ACP cladding is renowned for its strength, weather resistance, and longevity. Our installation ensures your building is equipped with reliable protection from external elements like rain, wind, and UV rays while maintaining a sleek, modern exterior. By choosing ACP cladding, you safeguard your property against the harshest weather conditions, ensuring the building remains attractive and durable for years to come."
  },
  {
    "WhyChooseheading": "Lightweight and Efficient",
    "WhyChoosedescription": "ACP panels are incredibly lightweight, making them easy to transport, handle, and install. This allows us to complete the installation process efficiently without compromising the structural integrity or design quality of your building. The lightweight nature of ACP panels not only reduces installation time but also provides cost-effective solutions, ensuring minimal disruption during the process."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "At Anjali Enterprises, we offer competitive pricing for all ACP cladding installation projects. Our pricing is designed to be transparent with no hidden charges, ensuring that you receive great value for your investment. We work with you to provide the most cost-effective solution that meets your aesthetic and functional needs, offering high-quality cladding at affordable rates."
  },
  {
    "WhyChooseheading": "Timely Installation",
    "WhyChoosedescription": "We respect your time and ensure that all ACP cladding installations are completed within the agreed-upon timeframe. Our team is committed to efficient project management, minimizing disruptions to your routine or business operations. With our focus on punctuality, you can rely on us to deliver results on time while maintaining the highest standards of quality."
  },
  {
    "WhyChooseheading": "Experienced Team",
    "WhyChoosedescription": "Anjali Enterprises boasts a team of highly skilled professionals with years of experience in ACP cladding installations. Our team is dedicated to precision, quality, and seamless project execution, ensuring that every installation meets the highest industry standards. From the initial design phase to the final installation, we manage each project with expertise and attention to detail."
  },
  {
    "WhyChooseheading": "Customer Satisfaction",
    "WhyChoosedescription": "Customer satisfaction is at the core of our values at Anjali Enterprises. We take pride in our proven track record of satisfied clients and successful projects. Our commitment to delivering high-quality ACP cladding installations that exceed your expectations has earned us a reputation for excellence. Whether for a commercial or residential property, we ensure a hassle-free experience, offering solutions that enhance your building’s appearance and functionality."
  }
]


  }
  const faqData = [
    {
      question: "What is ACP cladding, and why should I choose it for my building?",
      answer: "ACP cladding is a modern, durable, and lightweight material made of aluminum and polyethylene layers. It provides excellent protection against weather elements, is low-maintenance, and offers a sleek aesthetic finish for both residential and commercial buildings."
    },
    {
      question: "Can you customize the ACP cladding design to suit my building?",
      answer: "Yes, we offer fully customizable ACP cladding solutions. You can choose from a variety of colors, textures, and finishes to match your building’s style and architectural needs."
    },
    {
      question: "How long does the ACP cladding installation take?",
      answer: "The installation time depends on the size and complexity of the project. However, we strive to complete all installations efficiently and on time, with minimal disruption to your daily activities."
    },
    {
      question: "Is ACP cladding durable and long-lasting?",
      answer: "Yes, ACP cladding is highly durable and resistant to environmental factors such as heat, moisture, and UV radiation. It is designed to last for many years, making it a cost-effective solution for building exteriors."
    },
    {
      question: "How do I get a quote for ACP cladding installation?",
      answer: "You can contact us for a free consultation, and we will provide you with a detailed and transparent quote based on the size of the project and your specific requirements."
    },
    {
      question: "Can ACP cladding be installed on existing buildings?",
      answer: "Yes, ACP cladding can be installed on both new and existing buildings. Our team is experienced in retrofitting ACP cladding to enhance the appearance and performance of older buildings."
    },
    {
      question: "What makes ACP cladding better than other cladding materials?",
      answer: "ACP cladding is lightweight, cost-effective, durable, and offers excellent thermal insulation. It is also easier to maintain compared to other cladding materials, making it a popular choice for modern architecture."
    },
    {
      question: "How do I maintain ACP cladding?",
      answer: "ACP cladding is low-maintenance. Regular cleaning with mild detergent and water will keep the panels looking new. We also offer maintenance services to ensure your cladding remains in top condition."
    },
    {
      question: "Can ACP cladding be used for both exterior and interior applications?",
      answer: "Yes, ACP cladding is versatile and can be used for both exterior facades and interior applications, such as wall panels and ceilings, depending on your design preferences."
    },
    {
      question: "Why should I choose Anjali Enterprises for ACP cladding installation?",
      answer: "Anjali Enterprises offers high-quality ACP cladding panels, expert installation, and a focus on customer satisfaction. Our team is experienced, professional, and committed to delivering top-notch cladding solutions that meet your needs."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Akash Bansal",
      text: "Anjali Enterprises did an excellent job installing ACP cladding on the facade of our office building. The finish is stunning, and the panels have enhanced the building’s overall look. The team was professional, and the project was completed on time."
    },
    {
      name: "Mrs. Neelam Joshi",
      text: "We had Anjali Enterprises install ACP cladding for our residential project, and the results are fantastic! The cladding not only gives a modern look but also keeps our home protected from the elements. Highly recommended for anyone looking for durable and stylish cladding solutions."
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>


<Helmet>
  <title> ACP Cladding Panel Installation Services in Pune | Contact: +91 8793220265 </title>
  <meta name="description" content="Anjali Enterprises offers professional ACP Cladding Panel Installation services in Pune. We provide high-quality aluminum composite panels for building exteriors, facades, and home renovations. Call +91 8793220265 for expert ACP cladding solutions." />
  <meta name="keywords" content="ACP Cladding Installation Pune, Aluminum Composite Panel Cladding, Exterior Cladding Services, Facade Cladding Contractors, High-Quality ACP Panels for Building Exteriors, Cladding Installation for Buildings, Cladding Work for Commercial Buildings, ACP Panels for Office Facades, Exterior ACP Cladding, ACP Cladding for Home Renovations, Durable ACP Cladding" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | ACP Cladding Panel Installation Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers professional ACP Cladding Panel Installation services in Pune. We provide high-quality aluminum composite panels for building exteriors, facades, and home renovations. Call +91 8793220265 for expert ACP cladding solutions." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/acp-cladding-panel-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/acp-cladding-panel-installation" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers professional ACP Cladding Panel Installation services in Pune. We provide high-quality aluminum composite panels for building exteriors, facades, and home renovations. Call +91 8793220265 for expert ACP cladding solutions.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/acp-cladding-panel-installation",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/acp-cladding-panel-service.jpg",
        "priceRange": "₹5000 - ₹30000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/acp-cladding-panel-installation",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "42"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rahul D"
            },
            "datePublished": "2024-07-30",
            "reviewBody": "We had ACP cladding installed for our office building. Anjali Enterprises did a fantastic job with the installation, and the cladding looks very professional and durable."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha T"
            },
            "datePublished": "2024-09-12",
            "reviewBody": "The ACP cladding installed for our home renovation project has made a huge difference. The exterior looks modern, and the quality of the panels is excellent."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/acp-cladding-panel-installation"
        },
        "keywords": "ACP Cladding Installation Pune, Aluminum Composite Panel Cladding, Exterior Cladding Services, Facade Cladding Contractors, High-Quality ACP Panels for Building Exteriors, Cladding Installation for Buildings, Cladding Work for Commercial Buildings, ACP Panels for Office Facades, Exterior ACP Cladding, ACP Cladding for Home Renovations, Durable ACP Cladding"
      }
    `}
  </script>
</Helmet>



      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/4.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default ACPCladding;